const en = {
  ACTIVITY: 'Activity',
  ADD_INTERVAL: 'Add Interval',

  CREATE_ACTIVITY: 'Create Activity',
  CREATE_FILTER_CONFIGURATION: 'Save Filter',
  CONFIRM_FILTER_DELETE: 'Are you sure you want to delete the filter?',
  RECORDS: 'Records',
  RESTORE: 'Restore',
  CHANGE_PASSWORD: 'Change password',
  RUNNING: 'Running',
  SAVE: 'Save',
  SEARCH: 'Search',
  SAVE_FILTER_CONFIGURATION: 'Save Filter',
  SELECT_TIMEZONE: 'Select Timezone',
  SELECT_TYPES: 'Select Types',
  SELECT_ACTIVITY: 'Select Activity',
  SELECT_TAGS: 'Select Tags',
  SELECT_FILTER: 'Select Filter',
  SETTINGS: 'Settings',
  START_ACTIVITY: 'Start',
  LOG_ACTIVITY: 'Log',
  STATUS: 'Status',
  STOPPED: 'Stopped',
  STOP: 'Stop running activity',
  START: 'Start',
  TIME: 'Time',
  SIGN_IN: 'Sign In',
  SUMMARY: 'Summary',
  TIMEZONE: 'Timezone',
  TOTAL: 'Total',
  GROUPED: 'Trends',
  EDIT: 'Edit',
  EDIT_USER: 'Edit User',
  EDIT_ACTIVITY: 'Edit Activity',
  ENTER_USERNAME: 'Enter your username',
  ENTER_PASSWORD: 'Enter your password',
  FILTER_NAME_PLACEHOLDER: 'Enter Filter Name',
  PASSWORD: 'Password',
  REPEAT_PASSWORD: 'Repeat password',
  PAUSED: 'Paused',
  PAUSE: 'Pause running activity',
  FINISH: 'Finish',
  FORGOT_PASSWORD: 'Forgot Password',
  HISTORY: 'History',
  INTERVALS: 'Intervals',
  COMMENT: 'Comment',
  ADD_COMMENT: 'Add comment',
  EDIT_COMMENT: 'Click to edit the comment',
  COMMENT_SAVE_ERROR: 'Could not save the comment. Press Enter to retry.',
  DURATION: 'Duration',
  DOWNLOAD_HISTORY: 'Export',
  EXPORT: 'Export',
  EXPORT_PDF: 'PDF Report',
  EXPORT_PDF_ERROR_TITLE: 'Export Error',
  EXPORT_PDF_LIMIT_EXCEEDED: 'PDF export is limited to {limit} days. Selected range contains {days} days. Please select a smaller date range.',
  EXPORT_PDF_NO_DATA: 'No data to export for the selected date range.',
  EXPORT_EXCEL: 'Excel Report',
  EXPORT_EXCEL_ERROR_TITLE: 'Export Error',
  EXPORT_EXCEL_LIMIT_EXCEEDED: 'Excel export is limited to {limit} days. Selected range contains {days} days. Please select a smaller date range.',
  EXPORT_EXCEL_NO_DATA: 'No data to export for the selected date range.',
  TAGS: 'Tags',
  TODAY: 'Today',
  THIS_WEEK: 'This Week',
  THIS_MONTH: 'This Month',
  TYPE_ID: 'Activity Type',
  TYPES: 'Types',
  YES: 'Yes',
  YESTERDAY: 'Yesterday',
  NO: 'No',
  NO_RESULTS: 'No results found',
  NO_DATA_FOR_RANGE: 'No records for the selected date range',
  NO_DATA_FOR_RANGE_AND_FILTERS: 'No records for the selected date range and filters',
  NONE: 'Do nothing (2 or more activities will run)',
  DELETE: 'Delete',
  DELETE_ACTIVITY_CONFIRM: 'Are you sure you want to delete this activity? All intervals will be removed.',
  DELETE_INTERVAL: 'Delete the interval',
  DELETE_INTERVAL_CONFIRM: 'Are you sure you want to delete this interval?',
  INSERT_BETWEEN: 'Insert between',
  INSERT_NEW: 'Insert new',
  USER: 'User',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  LAST_WEEK: 'Last Week',
  LAST_MONTH: 'Last Month',
  LOAD_MORE: 'More..',
  USER_NAME: 'E-Mail',
  FULL_PATH: 'Display full path to activity type',
  LANGUAGE: 'Language',
  SELECT_LANGUAGE: 'Select Language',
  ON_START_ACTION: 'Action on start',
  FIRST_DAY_OF_WEEK: 'First day of week',
  FIRST_DAY_AUTO: 'Auto (from system)',
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  SATURDAY: 'Saturday',
  DARK_MODE: 'Dark Mode',
  GOALS: 'Goals',
  ADD_RECORD: 'Add record',
  CALENDAR: 'Calendar',
  CALENDAR_LIMIT_WARNING: 'Calendar view is limited to {days} days. Selected range contains {selected} days. Showing {showingFrom} - {showingTo}.',
  COPY: 'Copy',
  PASTE: 'Paste',
  ACTIVITY_COPIED: '"{name}" copied. Click on empty area to paste.',
  CANCEL: 'Cancel',
  DONE: 'Done',

  // API tokens (Settings)
  API_TOKENS: 'API Tokens',
  API_TOKENS_DESCRIPTION: 'Personal access tokens let external tools (MCP, CLI) access your account. Revoke a token at any time to cut off access.',
  API_TOKENS_LOAD_ERROR: 'Failed to load tokens. Please try again.',
  API_TOKEN_CREATE_ERROR: 'Failed to create the token. Please try again.',
  API_TOKEN_REVOKE_ERROR: 'Failed to revoke the token. Please try again.',
  API_TOKEN_CREATED: 'Token created',
  API_TOKEN_COPY_WARNING: 'Copy the token now — you won\'t be able to see it again.',
  API_TOKEN_REVOKE_CONFIRM: 'Revoke the token "{name}"? Tools using it will lose access immediately.',
  GENERATE_TOKEN: 'Generate token',
  TOKEN: 'Token',
  TOKEN_NAME: 'Name',
  TOKEN_NAME_PLACEHOLDER: 'e.g. Claude MCP',
  TOKEN_EXPIRATION: 'Expiration',
  EXPIRES_IN_DAYS: '{days} days',
  EXPIRES_NEVER: 'Never',
  CREATED: 'Created',
  LAST_USED: 'Last used',
  EXPIRES: 'Expires',
  NEVER_USED: 'Never',
  TOKEN_ACTIVE: 'Active',
  TOKEN_REVOKED: 'Revoked',
  TOKEN_EXPIRED: 'Expired',
  REVOKE: 'Revoke',
  NO_API_TOKENS: 'No API tokens yet',

  // Delete account (Settings)
  DELETE_ACCOUNT: 'Delete account',
  DELETE_ACCOUNT_DESCRIPTION: 'Permanently close your account and lose access to everything you have tracked.',
  DELETE_ACCOUNT_TITLE: 'Delete your account?',
  DELETE_ACCOUNT_WARNING: 'All of your data — activities, intervals, goals, tokens and settings — will be deleted, and every device signed in to this account will lose access. This cannot be undone.',
  DELETE_ACCOUNT_CONFIRM_PROMPT: 'Type "{word}" to confirm',
  DELETE_ACCOUNT_CONFIRM_WORD: 'delete',
  DELETE_ACCOUNT_ERROR: 'Failed to delete the account. Please try again.',

  // What's New
  WHATS_NEW_TITLE: "What's New",
  WHATS_NEW_GOT_IT: 'Got it!',
  WHATS_NEW_CALENDAR_TITLE: 'Calendar View',
  WHATS_NEW_CALENDAR_DESC: 'Visualize your time in a beautiful calendar layout:',
  WHATS_NEW_CALENDAR_FEATURE_1: 'Interactive week view with zoom controls',
  WHATS_NEW_CALENDAR_FEATURE_2: 'Click on empty slots to quickly add activities',
  WHATS_NEW_CALENDAR_FEATURE_3: 'Drag event edges to resize and adjust times',
  WHATS_NEW_CALENDAR_FEATURE_4: 'Copy and paste activities between days',
  WHATS_NEW_CALENDAR_FEATURE_5: 'Smart gap detection for inserting between events',
  WHATS_NEW_BLOCKS_TITLE: 'Blocks View',
  WHATS_NEW_BLOCKS_DESC: 'A compact grid view showing your day divided into 15-minute blocks. Hover to see details, click to edit.',
  WHATS_NEW_PDF_TITLE: 'PDF Export',
  WHATS_NEW_PDF_DESC: 'Generate detailed PDF reports with charts and activity breakdown for any date range.',
  WHATS_NEW_UI_TITLE: 'Refreshed Interface',
  WHATS_NEW_UI_DESC: 'Cleaner, more modern design with improved navigation and visual consistency.',
  WHATS_NEW_DARKMODE_TITLE: 'Quick Dark Mode Toggle',
  WHATS_NEW_DARKMODE_DESC: 'Dark mode is now accessible directly from the sidebar for easy switching anytime.',
  WHATS_NEW_FEEDBACK: 'Found an issue or have feedback about these changes? Contact us at',
}

export default en
